var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProgressDashboardSm = function SvgProgressDashboardSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    "data-name": "Progress Dashboard",
    viewBox: "0 0 22 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    "data-name": "Group 3788"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.001 19V3h.815v15.185h15.165V19zM17.459 7.347a1.2 1.2 0 0 1-.272-.032l-3 5.721a1.253 1.253 0 1 1-2.117.907c0-.04.008-.076.008-.116l-2.17-2.407a1.243 1.243 0 0 1-.687.208 1.156 1.156 0 0 1-.34-.055l-1.917 3.568a1.25 1.25 0 1 1-1-.5 1.4 1.4 0 0 1 .32.044l1.926-3.579a1.242 1.242 0 0 1-.244-.739 1.255 1.255 0 1 1 2.441.392l2.054 2.272a1.255 1.255 0 0 1 .863-.348c.04 0 .08.008.12.012l3.048-5.813a1.25 1.25 0 1 1 .967.463z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.584 5.997H7.309v-1h2.275V3.229l2.814 2.267-2.814 2.267z",
    "data-name": "Union 6"
  }))));
};
export default SvgProgressDashboardSm;